<mat-card fxFlex>
  <mat-card-title>Output</mat-card-title>
  <mat-card-content>
    <pre>{{selectedFacets | json }}</pre>
  </mat-card-content>
</mat-card>
